import { Box, Stack, Typography } from '@mui/material';

import type ReportFullWidthBoxProps from './ReportsFullWidthContainer.types';

const getJustifyContent = (align: string) => {
  if (align === 'center') return 'center';
  if (align === 'right') return 'flex-end';
  return 'flex-start';
};

const ReportFullWidthContainer = ({
  children,
  backgroundColor = '#eee',
  height = 'auto',
  textAlign = 'center',
  padding = '1rem',
  title
}: ReportFullWidthBoxProps) => {
  const testId = title?.split(' ').join('-').toLowerCase();
  return (
    <Box
      data-testid={testId || 'unknown-box-text-id'}
      sx={{
        backgroundColor,
        height,
        padding,
        marginLeft: '-10mm !important', // default MUI container padding
        marginRight: '-10mm !important',
        display: 'flex',
        alignItems: 'center',
        justifyContent: getJustifyContent(textAlign)
      }}
    >
      <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
        {title && (
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '20px',
              textTransform: 'uppercase'
            }}
          >
            {title}
          </Typography>
        )}
        {children}
      </Stack>
    </Box>
  );
};

export default ReportFullWidthContainer;
